import Footer from "components/footer/FooterAuthDefault";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import { useAuthStore, selectIsAuthenticated } from "store/authStore";

export default function Auth() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  if (hasHydrated && isAuthenticated) {
    return <Navigate to="/dashboard/home" replace />;
  }
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full !bg-[#F7F7F7] dark:!bg-navy-900">
        <FixedPlugin />
        <main className="mx-auto flex min-h-screen flex-col">
          <div className="relative flex flex-1 flex-col items-center justify-center px-4 py-12">
            <div className="w-full max-w-[420px] rounded-lg border border-[#EEE] bg-white p-6 shadow-sm">
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/auth/sign-in" replace />}
                />
              </Routes>
            </div>
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
}
